
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo2 from '../images/ergusLogo.png';
import facebook from '../images/social/facebook.png';
import instagram from '../images/social/instagram.png';

import lekeTedavisi from '../images/home/product_cat/16001613825223.jpg';
import ciltBakimi from '../images/home/product_cat/16002483614992.jpg';
import kimyasalPeeling from '../images/home/product_cat/1600248563806.jpg';
import botox from '../images/home/product_cat/16001621013040.jpg';
import dolgu from '../images/home/product_cat/16002484183426.jpg';
import prp from '../images/home/product_cat/16002484584606.jpg';
import mezoterapi from '../images/home/product_cat/16002485293517.jpg';
import dermoroller from '../images/home/product_cat/16001664438222.jpg';
import pdo from '../images/home/product_cat/16001666366178.jpg';

import { Link } from 'react-router-dom';
import '../styles/myFooter.css'

const MyFooter = () => {

  const handleScrollToTop = () => {
    window.scrollTo(0, 0)
  };

  const footerGalleryItems = [
    { title: 'Leke Tedavisi', imgSrc: lekeTedavisi },
    { title: 'Cilt Bakımı', imgSrc: ciltBakimi },
    { title: 'Kimyasal Peeling', imgSrc: kimyasalPeeling },
    { title: 'Botox Uygulamaları', imgSrc: botox },
    { title: 'Dolgu Uygulamaları', imgSrc: dolgu },
    { title: 'PRP Uygulamaları', imgSrc: prp },
    { title: 'Mezoterapi Uygulamaları', imgSrc: mezoterapi },
    { title: 'Dermoroller Uygulamaları', imgSrc: dermoroller },
    { title: 'PDO İpleri ve Cilt Germe', imgSrc: pdo },
  ];

  return (
    <div>
      {/* Üst randevu kısmı */}
      <div className='my-footer'>
        <div className='container-footer'>
          <div className='left-bottom-randevu'>
            <p>Hizmetlerimizden Faydalanmak İçin Online Randevu Alabilirsiniz!</p>
          </div>
          <div className='custom-icons-randevu'>
            <Link to="/iletisim" className='site-map-link-randevu' onClick={handleScrollToTop}>
              Randevu al
            </Link>
          </div>
        </div>
      </div>

      {/* Ana footer içeriği */}
      <div className='footer-bg'>
        <Container className='pt-3 pb-3'>
          <Row>
            {/* Sol logo kısmı */}
            <Col xs={12} md={3}>
              <Link to="/" onClick={handleScrollToTop}>
                <img src={logo2} alt='logo' className='footer-logo' />
              </Link>
            </Col>

            {/* Site Haritası */}
            <Col xs={12} md={3}>
              <div className='site-map'>
                <h5 className='site-map-title'>Site Haritası</h5>
                <Link to="/" className='site-map-link' onClick={handleScrollToTop}>Anasayfa</Link>
                <Link to="/biyografi" className='site-map-link' onClick={handleScrollToTop}>Biyografi</Link>
                <Link to="/kozmetik-uygulamalar" className='site-map-link' onClick={handleScrollToTop}>Kozmetik Uygulamalar</Link>
                <Link to="/lazer-uygulamalari" className='site-map-link' onClick={handleScrollToTop}>Lazer Uygulamaları</Link>
                <Link to="/kozmetik-uygulamalar-2" className='site-map-link' onClick={handleScrollToTop}>Tanı ve Tedavi</Link>
                <Link to="/iletisim" className='site-map-link' onClick={handleScrollToTop}>İletişim</Link>
              </div>
            </Col>

            {/* Galeri kısmı */}
            <Col xs={12} md={3}>
              <div className='site-map'>
                <h5 className='site-map-title'>Galeri</h5>
                <Container>
                  <Row className='justify-content-md-center g-1'>
                    {footerGalleryItems.map((item, index) => (
                      <Col key={index} xs={6} sm={6} md={4} lg={4} xl={4} className='mb-3'>
                        <Link
                          to={`/kozmetik-uygulamalar?title=${encodeURIComponent(item.title)}`}
                          className='site-map-link'
                          onClick={handleScrollToTop}
                        >
                          <img src={item.imgSrc} alt={item.title} className='footer-gallery' />
                        </Link>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </div>
            </Col>

            {/* İletişim bilgileri */}
            <Col xs={12} md={3}>
              <div className='site-map'>
                <h5 className='site-map-title'>İletişim</h5>
                <p>
                  <span style={{ fontWeight: 'bold' }}>Adres:</span> Efe Plaza İş Merkezi Akpınar Mahallesi 367. Sokak, No:2/54 Osmangazi/Bursa
                </p>
                <p>
                  <span style={{ fontWeight: 'bold' }}>Telefon:</span>
                  <a href="tel:+905300449565"> 0 (530) 044 95 65</a>
                </p>
                <div className="email-container"> {/* Yeni div */}
                  <p className="email-line">
                    <span className="contact-info-label">E-mail:</span> birsen@birsenergus.com
                  </p>
                  <p className="email-line">
                    birsenergus@yahoo.com
                  </p>
                </div>
                <p>
                  <span style={{ fontWeight: 'bold' }}>Çalışma Saatleri:</span> Hafta içi 09:00 - 18:00
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Alt kısımdaki copyright ve sosyal medya ikonları */}
      <div className='my-footer'>
        <div className='container-footer'>
          <div className='left-bottom'>
            <p>© 2025 Uzm. Dr. Birsen Ergus. Tüm Hakları Saklıdır.</p>
          </div>
          <div className='custom-icons'>
            <div className='icon-bg'>
              <a
                href="https://www.facebook.com/p/Dr-Birsen-Ergus-Dermotoloji-ve-Estetik-Klini%C4%9Fi-100063494563308/?locale=tr_TR"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebook} className='social-media-icon' alt='Facebook' />
              </a>
            </div>
            <div className='icon-bg'>
              <a
                href="https://www.instagram.com/uzmdr.birsenergus/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} className='social-media-icon' alt='Instagram' />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyFooter;